import React from 'react'
import useTutorialSettings from '../../TutorialSettingsProvider/useTutorialSettings'
import BigForwardIcon from '../../ForwardIcon/BigForwardIcon'
import SmallForwardIcon from '../../ForwardIcon/SmallForwardIcon'

type PrimaryButtonIconProps = {
  label: string
}

const PrimaryButtonIcon = ({ label }: PrimaryButtonIconProps) => {
  const { tutorialSettings } = useTutorialSettings()

  const getIconSize = () => {
    if (tutorialSettings.stepIndex === 0) {
      return <BigForwardIcon />
    }
    return <SmallForwardIcon />
  }

  if (label !== 'Next') return null

  return getIconSize()
}

export default PrimaryButtonIcon
